import styled from 'styled-components';

export const Title = styled.div`
  font-size: 2rem;
  font-weight: 700;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center
  padding: 1rem 2rem;
`;
